import React from "react";
import { dicNames, i18n } from '../../../lang/i18n';
import DC from "../../../common/DataConnector";
import BackArrow from "../../../components/BackArrowComponent/BackArrow";
import DeliverOrder, { RenderStatus } from "./DeliveryOrder";
import { NavLink, useNavigate } from "react-router-dom";
import LocalDataStore from "../../../common/LocalDataStore";
import { appDataLoad } from "../../../store/AppData/AppData";
import dayjs from 'dayjs';
import PayWithCardRedsys from "../../CartAndPayment/PayWithCardRedsys";
import HelperProducts from "../../../common/HelperProducts";
import { CustomerDeliveryOrderStatus, PaymentStatus } from "../../../common/Enums";
import ScrollToTop from "../../../components/ScrollToTop";
import { actAlertShow, actLoading, actLoadingEnd } from "../../../store/Actions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

export default function DeliveryOrders()
{
    const dispatch = useAppDispatch()
    const appConf = useAppSelector((state) => state.appConf)
    const productExtras = useAppSelector((state) => state.appData.productExtras)
    const navigate = useNavigate();
    const [orders, setOrders] = React.useState<any[]>([])
    const [order, setOrder] = React.useState<any>(undefined)
    const [loaded, setLoaded] = React.useState(false)

    React.useEffect(() =>
    {
        (async function ()
        {
            await loadOrders()
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function loadOrders()
    {
        let content = await DC.Get('/customer/delivery-orders');
        if (content.wasOk) {
            setOrders(content.data);
            setLoaded(true)
        }
    }
    function onSelectOrder(order: any)
    {
        if (order.paymentStatus.id !== PaymentStatus.PayOk) return null;
        setOrder(order)
    }
    async function onLoadONLINE()
    {
        const locationCode = 'ONLINE';
        LocalDataStore.locationSet(locationCode);
        await appDataLoad(locationCode, dispatch)
        navigate('/user/deliver_orders')
    }

    async function onGetRedsysData(order: any)
    {
        actLoading(dispatch)
        let content = await DC.PostData('/customer/delivery-orders/' + order.orderId + '/pay', {});
        if (content.wasOk) {
            actLoadingEnd(dispatch)
            onLoadONLINE();
            return content.data;
        } else {
            actAlertShow(dispatch, 'warning', i18n.Errors.ErrorRetrievingInformation);
        }
        actLoadingEnd(dispatch)
    }

    async function onOrderCancel(order: any)
    {
        actLoading(dispatch)
        let content = await DC.Delete('/customer/delivery-orders/' + order.orderId);
        if (content.wasOk) {
            await loadOrders()
        } else {
            actAlertShow(dispatch, 'warning', i18n.Errors.ErrorSavingData);
        }
        actLoadingEnd(dispatch)
    }

    function renderState(order: any)
    {
        if (order.orderStatus.id === CustomerDeliveryOrderStatus.Delivered)
            return <div className="row row-state-ready">
                <div className="col-6">{order.orderStatus.name}</div>
                <div className="col-6 text-right">{order.totalProducts} {i18n.DeliveryOrders.Products} {order.totalPrice}€</div>
            </div>
        if (order.paymentStatus.id !== PaymentStatus.PayOk)
            return <div className="row row-state-ko">
                <div className="col-6">{dicNames[CustomerDeliveryOrderStatus.Waiting]}</div>
                <div className="col-6 text-right">{order.totalProducts} {i18n.DeliveryOrders.Products} {order.totalPrice}€</div>
            </div>
        return <div className="row row-state-ok">
            <div className="col-6">{order.orderStatus.name}</div>
            <div className="col-6 text-right">{order.totalProducts} {i18n.DeliveryOrders.Products} {order.totalPrice}€</div>
        </div>
    }

    return (<div className="users">
        <ScrollToTop />
        <div className="main-subtitle">
            <h3>{i18n.DeliveryOrders.Title}</h3>
        </div>
        {loaded && orders.length === 0 && <div className="text-center">
            <p>{i18n.DeliveryOrders.WithoutOrdersLine1}</p>
            <p>{i18n.DeliveryOrders.WithoutOrdersLine2}</p>
            <p>{i18n.DeliveryOrders.WithoutOrdersLine3}</p>
            <p>{i18n.DeliveryOrders.WithoutOrdersLine4}</p>
            <h4 className="text-center mt-5">{i18n.DeliveryOrders.DoYouWantOrder}</h4>
            <div className="box">
                <br />
                <div className="container main-subtitle mt-1">
                    <NavLink to="/" className="btn-back link-btn"> <i className="fa fa-home" />{i18n._Labels.SeeProducts}</NavLink>
                </div>
                <br />
            </div>
        </div>}
        {!order && <div className="orders">
            {orders.map((item: any, index: number) => (
                <div key={index} className="invoice p-2" onClick={() => onSelectOrder(item)}>
                    <div className="row row-title">
                        <div className="col-6">{dayjs(item.orderDate).format("DD/MM/YYYY")}</div>
                        <div className="col-6 text-right">{item.orderCode}</div>
                    </div>
                    {renderState(item)}
                    <hr className="mt-4"></hr>
                    {item.products.map((product: any, p_index: number) => (
                        <div className="row" key={p_index}>
                            <div className="col-12">{HelperProducts.ProductDescription(productExtras, product)}</div>
                        </div>
                    ))}
                    <hr className="mb-4" />
                    <div className="row">
                        {RenderStatus(item, appConf.colors)}
                    </div>
                    {item.paymentStatus.id !== PaymentStatus.PayOk && <div className="row">
                        <div className="col-12 p-3 text-center">
                            <PayWithCardRedsys onGetRedsysData={onGetRedsysData} totalPrice={item.totalPrice} title={i18n.TabCart.PayWithCard} style={{ maxWidth: '80%' }} />
                        </div>
                        <div className="col-12 p-3 text-center">
                            <button className="btn btn-outline-dark mt-3 btn-pay" onClick={() => onOrderCancel(item)} style={{ maxWidth: '80%' }}>
                                {i18n.Orders.CancelOrder}
                            </button>
                        </div>

                    </div>}
                </div>
            ))}
            <BackArrow path="/user" />
        </div>}
        {order && <DeliverOrder order={order} onClose={() => setOrder(undefined)} />}
    </div>
    );
}